'use strict';

define('components/nav/images.lazyload',['./navigation', 'lazyload'], function (Navigation) {
  var ImagesLazyLoadPlugin = Navigation.Plugin.extend({
    bindEvents: function () {
      var nav = this.getNavigation();
      $(nav).on('loadimages', function (event, scopeObj) {
        $('img.lazy', scopeObj.$scope).lazy({
          bind: 'event',
          delay: 0
        });
      });
    }
  });

  Navigation.registerPlugin(ImagesLazyLoadPlugin);
});

